import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { MakineTanimiEditComponent } from './makine-tanimi-edit.component';
import { MakineTanimiKartComponent } from './makine-tanimi-kart.component';
import { MakineTanimiKartSadeComponent } from './makine-tanimi-kart-sade.component';

@DinamikBilesen({
  id: 'makine-tanimi',
  baslik: 'Makine Tanımı',
  aciklama: 'Makine ve tezgah tanımla',
  ikon: 'tool',
  kategori: 'uretim',
})
class MakineTanimi {
  paylas_kutusu = MakineTanimiEditComponent;
  paylasilmis_kart = MakineTanimiKartComponent;
  paylasilmis_kart_sade = MakineTanimiKartSadeComponent;
}
